///there is a promo called "inheritgold" where we pay agents a little bit more if they exceed a certain number of plans referred to us each calendar year.
//Currently what it does is get all matters that the agent has referred to us and see when they paid, and then count if it's greater than or equal to 5
//then it will say we need to turn on this "inheritgold" promo for them and start paying more


import lawService from "./simpleAjax.js";
import customLawService from "./customAjax.js";
export default async function checkForInheritGold(fieldAgentResponse,areWeMarkingPayment,matterName,email){
    try{
    let agentInfo= fieldAgentResponse
    let customFields=agentInfo.data.data.attributes.custom_fields
    let id=agentInfo.data.data.id
    let agentCode=0
    for (let i = 0; i < customFields.length; i++) {
        const element = customFields[i];
        if(element.id==="434123")
        {
            agentCode=element.value
        }
    }
    if(agentCode)
    {
        //agent code is something all WFG agents have that uniquely demarkates who they are. Each referred matter has an agent code in the "hobbies" field in lawmatics 
        //that identifies who referred them.
        //we filter on all matters with a certain agent code and see which plans they have purchased to determine if it qualifies towards
        //the up to 5 necessary referrals to get INheritgold
        let upperCode=agentCode.toUpperCase()
        let lowerCode=agentCode.toLowerCase()
        let matters1=await lawService.getMattersByAgentId(upperCode)
        let matters2=await lawService.getMattersByAgentId(lowerCode)
        let matters1Array=matters1.data.data
        let matters2Array=matters2.data.data
        let matterArray=matters1Array.concat(matters2Array)
        let paidClients=areWeMarkingPayment?1:0
        let validTags={
            "146977":"Agent Sold TrustGuard Plus+ Plan",
            "147028":"Attorney Sold TrustGuard Plus+ Plan",
            "153067":"WealthGuard Purchased",
            "153068":"TrustGuard Purchased",
        }
        for (let i = 0; i < matterArray.length; i++) {
            const currentMatter = matterArray[i];
            let tags=currentMatter.relationships.tags.data
            for (let j = 0; j < tags.length; j++) {
                const currentTag = tags[j];
                if(validTags[currentTag.id]&& currentMatter.attributes.converted_date>='2026-01-01')
                {
                    paidClients++
                    break
                }
            }
          
        }
        if(paidClients>=5)
        {
        lawService.markInheritgold(id)
           return true
        }
        else{
            return false
        }
    }
    else{

    }
    }
    catch{
        //the everee form is a generic lawmatics form that triggers and email to me letting me know something errored out in the processes
        //after client payment.
       customLawService.submitEvereeForm(
                     'matterName',
                     'email',
                     "Field%20Agent%20Error"
                   );
    }
}